import PropTypes from 'prop-types'
import { motion } from 'framer-motion'

import { useReducedMotionPreference, DURATION } from '../../../styles/motion'
import styles from './Chip.module.css'

const VARIANT_CLASS = {
  neutral: styles.neutral,
  success: styles.success,
  error: styles.error,
}

// Spec §5.6 — small status pill, enters with a fade-up (250ms).
const Chip = ({ variant, children, icon }) => {
  const reduceMotion = useReducedMotionPreference()

  return (
    <motion.span
      className={[styles.chip, VARIANT_CLASS[variant]].join(' ')}
      initial={reduceMotion ? false : { opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: DURATION.listItemFadeUp }}
    >
      {icon}
      {children}
    </motion.span>
  )
}

Chip.propTypes = {
  variant: PropTypes.oneOf(['neutral', 'success', 'error']),
  children: PropTypes.node.isRequired,
  icon: PropTypes.node,
}

Chip.defaultProps = {
  variant: 'neutral',
}

export default Chip
